const PDFJS_VERSION = '2.3.200';

// from src/assets/examplePDF.png
export const EXAMPLE_PDF = 'https:////img1.wsimg.com/isteam/ip/static/example-pdf/examplePDF.png'; // eslint disable-line

export const PDFJS_SCRIPT = `https://img1.wsimg.com/isteam/ip/static/pdf.js/${PDFJS_VERSION}/pdf.min.js`;
export const PDFJS_WORKER = `https://img1.wsimg.com/isteam/ip/static/pdf.js/${PDFJS_VERSION}/pdf.worker.min.js`;
